import {useRef } from 'react'


const defaultFunctionalAreas=[
    {
      "area": "Engineering"
    },
    {
      "area": "Purchasing"
    },
    {
      "area": "Quality"
    },
    {
      "area": "Production"
    },
    {
      "area": "General Manager"
    },
    {
      "area": "Sales"
    }
  ];
  
const defaultWarnings=[
    {
      "name": "Deadline approaching",
      "color": "#ffa500",
      "days": 7
    },
    {
      "name": "Overdue task",
      "color": "#ff2e00",
      "days": "2"
    },
    {
      "name": "Stale task",
      "color": "#ffff00",
      "days": "5"
    }
  ];
  
export {defaultWarnings as warningItems};
export {defaultFunctionalAreas as functionalAreas};
